import React from 'react';
import { Typography, Grid } from 'antd';
import NotificationsTable from '../components/notifications/NotificationsTable';

const { Title } = Typography;

const Notifications = () => {
  // Mobile (< md) : marges et titre réduits ; `=== false` évite un flash avant la mesure
  const screens = Grid.useBreakpoint();
  const isMobile = screens.md === false;

  return (
    <div style={{ padding: isMobile ? 12 : 24 }}>
      <Title level={isMobile ? 4 : 2} style={{ marginBottom: isMobile ? 12 : 24 }}>
        Notifications des Articles
      </Title>
      <NotificationsTable />
    </div>
  );
};

export default Notifications;
